module.exports = __webpack_public_path__ + "static/media/ypsi library.089f087d.jpg";